var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin2Line(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20.7731L5.69667 15.4698C4.64779 14.4209 3.93349 13.0845 3.64411 11.6296C3.35473 10.1748 3.50326 8.6668 4.07092 7.29636C4.63858 5.92592 5.59987 4.75458 6.83324 3.93048C8.0666 3.10637 9.51665 2.6665 11 2.6665C12.4834 2.6665 13.9334 3.10637 15.1668 3.93048C16.4001 4.75458 17.3614 5.92592 17.9291 7.29636C18.4967 8.6668 18.6453 10.1748 18.3559 11.6296C18.0665 13.0845 17.3522 14.4209 16.3033 15.4698L11 20.7731ZM15.125 14.2914C15.9407 13.4756 16.4963 12.4362 16.7213 11.3047C16.9463 10.1731 16.8308 9.00027 16.3892 7.9344C15.9477 6.86853 15.2 5.95753 14.2408 5.31658C13.2815 4.67563 12.1537 4.33353 11 4.33353C9.8463 4.33353 8.71851 4.67563 7.75924 5.31658C6.79996 5.95753 6.05229 6.86853 5.61076 7.9344C5.16923 9.00027 5.05368 10.1731 5.27871 11.3047C5.50374 12.4362 6.05926 13.4756 6.875 14.2914L11 18.4164L15.125 14.2914ZM11 11.8331C10.558 11.8331 10.1341 11.6575 9.82149 11.3449C9.50893 11.0324 9.33334 10.6085 9.33334 10.1664C9.33334 9.72441 9.50893 9.30049 9.82149 8.98793C10.1341 8.67537 10.558 8.49977 11 8.49977C11.442 8.49977 11.866 8.67537 12.1785 8.98793C12.4911 9.30049 12.6667 9.72441 12.6667 10.1664C12.6667 10.6085 12.4911 11.0324 12.1785 11.3449C11.866 11.6575 11.442 11.8331 11 11.8331Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin2Line);
export default __webpack_public_path__ + "static/media/map-pin-2-line.9e4202cd.svg";
export { ForwardRef as ReactComponent };